export default __webpack_public_path__ + "static/media/288.d099c91e.jpg";